import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const PageContainer = styled(Box)({
    display: 'flex',
    padding: '0px',
    gap: '0px',
});

export const ContentContainer = styled(Box)({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
});
